enum DateFormat {
  HourMinute = 'HH:mm',
  DayNumberDayName = 'DD ddd',
  YearMonthDay = 'YYYY-MM-DD',
  MonthName = 'MMMM',
  Year = 'YYYY',
  YearMonth = 'YYYY-MM',
  DayNumberDayFullName = 'DD dddd',
  DayName = 'dddd',
  DayMonthNameYear = 'D MMMM YYYY',
  DayMonthYear = 'DD.MM.YYYY',
  YearMonthDayBracketDayFullName = '[[]YYYY-MM-DD] dddd',
  YearMonthDayHoursMinutes = 'YYYY-MM-DD HH:mm',
  DayTwoMonthNameYear = 'DD MMMM YYYY',
  MonthYear = 'MM YYYY',
  IsoLocalDateTime = 'YYYY-MM-DD[T]HH:mm:ss',
  DayMonthYearTime = 'DD.MM.YYYY HH:mm',
}

export default DateFormat
